import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-cellsignalnone",
  "use": "icon-th-cellsignalnone-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-cellsignalnone\">\n<path d=\"M6 24V25C6 25.2652 5.89464 25.5196 5.70711 25.7071C5.51957 25.8946 5.26522 26 5 26C4.73478 26 4.48043 25.8946 4.29289 25.7071C4.10536 25.5196 4 25.2652 4 25V24C4 23.7348 4.10536 23.4804 4.29289 23.2929C4.48043 23.1054 4.73478 23 5 23C5.26522 23 5.51957 23.1054 5.70711 23.2929C5.89464 23.4804 6 23.7348 6 24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-cellsignalnone.svg
// module id = DDWk
// module chunks = 84